import { useAuth } from '@/context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { HandHeart, Calendar, Newspaper, User, Inbox, Award } from 'lucide-react';

export default function MemberDashboard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate('/login');
    if (!loading && user?.role === 'admin') navigate('/admin');
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="py-24 text-center">Loading…</div>;

  return (
    <div className="bg-[#F8F9FA] min-h-screen py-16">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center gap-4 mb-10">
          {user.picture ? <img src={user.picture} alt="" className="w-16 h-16 rounded-full border-2 border-gold" /> : <div className="w-16 h-16 rounded-full bg-royal flex items-center justify-center border-2 border-gold text-gold font-serif text-2xl">{user.name?.[0]}</div>}
          <div>
            <div className="overline">Welcome</div>
            <h1 className="font-serif text-3xl text-royal font-bold">{user.name}</h1>
            <div className="text-sm text-charcoal-muted">{user.email}</div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { icon: Inbox, title: 'Direct Messages', to: '/inbox' },
            { icon: Award, title: 'Claim a Ministry Position', to: '/claim-position' },
            { icon: HandHeart, title: 'Submit a Prayer Request', to: '/prayer' },
            { icon: Calendar, title: 'View Events Calendar', to: '/calendar' },
            { icon: Newspaper, title: 'Read Jurisdiction News', to: '/news' },
            { icon: User, title: 'Church Locator', to: '/locator' },
          ].map(a => (
            <Link key={a.title} to={a.to} className="card-tactile p-6 group">
              <a.icon className="w-6 h-6 text-gold mb-3" />
              <div className="font-serif text-lg text-royal font-bold group-hover:text-gold transition">{a.title}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
